module.exports = __webpack_public_path__ + "img/icon-13.24b1c7f9.png";